<template>
  <div>
    <router-view/>
    <toast-container/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
